import { render, staticRenderFns } from "./BonusProductionList.vue?vue&type=template&id=4770a609"
import script from "./BonusProductionList.vue?vue&type=script&lang=js"
export * from "./BonusProductionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports